import React from 'react';

const Arrow = ({className, style}) => (
  <div className={className} style={{...style}} >
    <svg version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="36px" height="36px" viewBox="0 0 255 255" style={{enableBackground: 'new 0 0 255 255'}} xmlSpace="preserve"><polygon points="0,90 62,210 124,90" fill="#7594A6" /></svg>
  </div>
);

Arrow.defaultProps = {
  style: {
    position:"absolute",
    zIndex:"0",
    bottom:0,
    right:1,
  },
};

export default Arrow;
